import { Message } from 'element-ui'

// 校验响应错误
export const $validateRes = (data, tipError = true) => {
  return new Promise((res, rej) => {
    if(data.error_code === 0) {
      res(data)
    }else if(data.error_code) {
      tipError && Message.error(data.error_message)
      rej(data)
    }
  })
}